// お問い合わせ関連のルート設定
const InquiryMain = () => import('@/views/inquiry/InquiryMain.vue')
const InquiryLinkDisplay = () => import('@/views/inquiry/InquiryLinkDisplay.vue')
const InquiryGuide = () => import('@/views/inquiry/InquiryGuide.vue')
const InquiryTextInput = () => import('@/views/inquiry/InquiryTextInput.vue')
const InquiryComplete = () => import('@/views/inquiry/InquiryComplete.vue')

export default [
  {
    path: '/inquiry',
    name: 'InquiryMain',
    component: InquiryMain,
    meta: {
      title: 'お問い合わせ'
    }
  },
  {
    path: '/inquiry/link-display',
    name: 'InquiryLinkDisplay',
    component: InquiryLinkDisplay,
    props: route => ({
      categoryId: route.params.categoryId,
      categoryLabel: route.params.categoryLabel,
      links: route.params.links,
      guideText: route.params.guideText
    }),
    meta: {
      title: 'リンク選択'
    }
  },
  {
    path: '/inquiry/guide',
    name: 'InquiryGuide',
    component: InquiryGuide,
    props: route => ({
      categoryId: route.params.categoryId,
      categoryLabel: route.params.categoryLabel,
      guideText: route.params.guideText
    }),
    meta: {
      title: 'お問い合わせ案内'
    }
  },
  {
    path: '/inquiry/text-input',
    name: 'InquiryTextInput',
    component: InquiryTextInput,
    props: route => ({
      categoryId: route.params.categoryId,
      categoryLabel: route.params.categoryLabel
    }),
    meta: {
      title: 'お問い合わせ内容入力'
    }
  },
  {
    path: '/inquiry/complete',
    name: 'InquiryComplete',
    component: InquiryComplete,
    props: route => ({
      categoryId: route.params.categoryId,
      categoryLabel: route.params.categoryLabel,
      completionMessage: route.params.completionMessage
    }),
    meta: {
      title: 'お問い合わせ完了'
    }
  }
]


// WEBPACK FOOTER //
// ./src/router/inquiry/index.js